import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { useHandler } from 'src/hooks'
import styles from './Checkable.scss'

/**
 * Awesome checkable.
 */
const Checkable = ({ type, label, className, style, readOnly, onChange, ...domProps }) => {
  // disabled checkbox if readonly and call original onChange with correct value
  const enhancedOnChange = useHandler(
    event => onChange && !readOnly && onChange(type === 'checkbox' ? event.target.checked : event.target.value)
  )
  return (
    <label className={classnames(styles.checkable, className, { [styles.readOnly]: readOnly })} style={style}>
      <input
        {...domProps}
        onChange={enhancedOnChange}
        type={type}
        readOnly={readOnly}
        className={classnames(styles.input, {
          [styles.checked]: domProps.checked,
        })}
      />
      <span className={styles.text}>{label}</span>
    </label>
  )
}

Checkable.defaultProps = {
  type: 'checkbox',
}

Checkable.propTypes = {
  /**
   * Checkbox or Radio type
   */
  type: PropTypes.oneOf(['checkbox', 'radio']),
  /**
   * The checkable label.
   */
  label: PropTypes.node,
  /**
   * A classname to apply to the checkable wrapper.
   */
  className: PropTypes.string,
  /**
   * Whether or not the input is read-only
   */
  readOnly: PropTypes.bool,
  /**
   * A style object to apply to the checkable wrapper.
   */
  style: PropTypes.object,
  /**
   * Function called on input change
   */
  onChange: PropTypes.func,
}

export default Checkable
